import { Controller } from '@hotwired/stimulus'

// 記事の目次(TOC)スクロール追従コントローラー（jQuery 非依存）
// - 目次リンク(data-toc-target="link")の href(#id) から本文見出しを引き当て、
//   IntersectionObserver で現在地の見出しに対応するリンクへ is-active を付与する。
//   （見出しは本文側＝コントローラー要素の外にあるため target ではなく id で解決する）
// - 目次リンククリック時はスムーズスクロールする。
export default class extends Controller {
  static targets = ['link']

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.onIntersect(entries),
      { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    )
    this.linkTargets.forEach((link) => {
      const id = link.getAttribute('href').slice(1)
      const heading = document.getElementById(id)
      if (heading) {
        this.observer.observe(heading)
      }
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return
      }
      const id = entry.target.id
      this.linkTargets.forEach((link) => {
        const isActive = link.getAttribute('href') === `#${id}`
        link.classList.toggle('is-active', isActive)
        link.classList.toggle('text-brand-700', isActive)
        link.classList.toggle('font-bold', isActive)
      })
    })
  }

  scrollTo(event) {
    event.preventDefault()
    const id = event.currentTarget.getAttribute('href').slice(1)
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      history.replaceState(null, '', `#${id}`)
    }
  }
}
